import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GeneralsService } from './services/generals.service';
declare let fbq:Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Vendido.Shop';
  constructor(private router: Router ,private genS:GeneralsService){
    
    // router.events.subscribe((y: any) => {
    //   if(y instanceof NavigationEnd){
    //     fbq('track', 'PageView');
    //   }
    // })
    
      
  // this.genS.getVisits().subscribe();
  }
}
